import React, { CSSProperties } from "react";
import { NavLink } from "react-router";

interface LinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  title?: string;
  end?: boolean;
  style?: CSSProperties;
}

export default function Link(props: LinkProps): React.JSX.Element {
  const { to, children, ...rest } = props;

  return (
    <NavLink to={to} {...rest}>
      {children}
    </NavLink>
  );
}

